import React, { useEffect, useState } from "react";
import { collection, query, where, onSnapshot, updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase";

const PdfList = ({ collectionPath, nomSection }) => {
  const [pdfs, setPdfs] = useState([]);

  useEffect(() => {
    // Requête pour récupérer les rapports actifs
    const q = query(
      collection(db, collectionPath),
      where("active", "==", true)
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const pdfList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPdfs(pdfList);
    });

    return () => unsubscribe();
  }, [collectionPath]);

  const archivePdf = async (pdfId) => {
    try {
      const pdfDocRef = doc(db, collection, pdfId);
      await updateDoc(pdfDocRef, { active: false });
      alert("Document archivé avec succès !");
    } catch (error) {
      console.error("Erreur lors de l'archivage du document :", error);
    }
  };

  return (
    <div className="pt-4 md:pt-6">
      <h2 className="md:text-xl text-secondary mb-4 text-center font-bold">{nomSection}</h2>
      
      {pdfs.length === 0 ? (
        <p className="text-center text-gray-500">Aucun PDF disponible.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 md:gap-4">

          {pdfs.map((pdf) => (
            <div
              key={pdf.id}
              className="border rounded-lg shadow-sm p-4 m-2 md:m-0 bg-white flex flex-col justify-between"
            >
            
              <div className="flex items-center">
                <div className="w-8 h-8 flex-shrink-0 bg-gray-100 rounded-lg flex items-center justify-center">
                  <span className="text-lg text-blue-500">📄</span>
                </div>
                <div className="ml-2 flex-1 min-w-0">
                  <h3 className="text-md font-semibold text-gray-800 break-words">
                    {pdf.nom || "Sans nom"}
                  </h3>
                  <p className="text-sm text-gray-500">
                    {new Date(pdf.dateCreation?.seconds * 1000).toLocaleDateString("fr-FR")}
                  </p>
                </div>
              </div>

            
              <div className="mt-4 flex justify-between">
                <button
                  onClick={() => window.open(pdf.url, "_blank")}
                  className="px-4 py-2 bg-primary text-white text-sm rounded-lg hover:bg-secondary "
                >
                  Ouvrir
                </button>
                {/*<button
                  onClick={() => archivePdf(pdf.id)}
                  className="px-4 py-2 bg-red-500 text-white text-sm rounded-lg hover:bg-red-600"
                >
                  Archiver
                </button>*/}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PdfList;
